import template from './lmPdfHeader.html';
import './style.scss';

export default {
  template,
  bindings: {
    pdfTitle: '@',
    totalAmount: '@',
    adviserName: '@',
    loanTerms: '@',
    interestRate: '@',
    frequency: '@',
    date: '@',
    isHideDetails: '<',
  },
};
